import { colors } from '../../theme/colors';
import spacing, { isMobileScreen } from '../../theme/spacing';
import { fontSize } from '../../theme/typography';

type LabelTextProps = {
  text?: string | null;
  style?: any;
  error?: boolean;
  marginBottom?: boolean;
  marginTop?: boolean;
};

const getFontSize = ({ error }: { error?: boolean }) => {
  if (error) {
    return fontSize.xs + 0.75;
  }
  return fontSize.sm;
};

export default function LabelText({
  text,
  style,
  error,
  marginBottom,
  marginTop,
}: LabelTextProps) {
  return (
    <div
      style={{
        color: error ? colors.redLight : colors.textGreyMedium,
        fontSize: getFontSize({ error }),
        marginBottom: marginBottom ? spacing.small : 0,
        marginTop: marginTop ? spacing.small : 0,
        ...style,
      }}
    >
      {text || ''}
    </div>
  );
}
